import { Capacitor } from '@capacitor/core';

// Tells Capgo that the app loaded successfully.
// Without this call, Capgo rolls back to the previous bundle after a timeout (safety mechanism).
export default defineNuxtPlugin(() => {
  if (!Capacitor.isNativePlatform()) return;

  const { data: session } = useAuth();

  import('@capgo/capacitor-updater').then(({ CapacitorUpdater }) => {
    CapacitorUpdater.notifyAppReady();

    // Sent as custom_id with every update check so the server can offer beta bundles to OTA beta testers.
    // Only cleared on logout (not while the session is still loading at app start), the plugin persists it across restarts.
    watch(
      () => session.value?.userUuid,
      (userUuid, previousUserUuid) => {
        if (userUuid) {
          CapacitorUpdater.setCustomId({ customId: userUuid });
        } else if (previousUserUuid) {
          CapacitorUpdater.setCustomId({ customId: '' });
        }
      },
      { immediate: true },
    );

    // Activate new bundle immediately after download instead of waiting for next app start.
    CapacitorUpdater.addListener('updateAvailable', async (info) => {
      await CapacitorUpdater.set(info.bundle);
    });
  });

  import('@capacitor/splash-screen').then(({ SplashScreen }) => {
    SplashScreen.hide();
  });
});
